<div class="div" *ngIf="d">

    <qp-device-info [data]=data  [light]="light"></qp-device-info>

</div>